import { render, staticRenderFns } from "./AnalogSettingItemAnalogsModal.vue?vue&type=template&id=135c71bc&scoped=true&"
import script from "./AnalogSettingItemAnalogsModal.vue?vue&type=script&lang=js&"
export * from "./AnalogSettingItemAnalogsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c71bc",
  null
  
)

export default component.exports